<template>
  <div class="login-wrapper">
    <div class="login-container">
      <div class="login-logo">
        <img src="images/logo/logo.png" alt="Medicater logo">
      </div>

      <div class="login-card">
        <div class="login-header">
          <h2>Welcome Back</h2>
          <p>Sign in to your account</p>
        </div>

        <form id="login-form" v-on:submit.prevent="login">
          <div class="input-group">
            <span class="input-icon"><i class="ft-user"></i></span>
            <input type="text" id="username" placeholder="Username" required v-model="username">
          </div>

          <div class="input-group">
            <span class="input-icon"><i class="ft-lock"></i></span>
            <input :type="showPassword ? 'text' : 'password'" id="password" placeholder="Password" required v-model="password">
            <button type="button" class="eye-toggle" @click="showPassword = !showPassword" tabindex="-1">
              <i :class="showPassword ? 'ft-eye-off' : 'ft-eye'"></i>
            </button>
          </div>

          <label class="remember-row">
            <input type="checkbox" v-model="rememberUsername" class="remember-check">
            <span class="remember-label">Remember username</span>
          </label>

          <transition name="fade">
            <div class="error-box" v-if="errorMsg">
              <i class="ft-alert-circle"></i> {{ errorMsg }}
            </div>
          </transition>

          <button type="submit" class="login-btn" :disabled="loading">
            <span v-if="!loading">Sign In</span>
            <span v-else class="btn-loading">
              <span class="btn-spinner"></span>
              Signing in…
            </span>
          </button>

          <div class="login-links">
            <a href="https://admin.medicater.co.za/login/forgot_password" target="_blank" v-if="platformId == 'browser'">Forgot Password?</a>
            <a href="#" v-if="platformId != 'browser'" v-on:click.prevent="ForgotP()">Forgot Password?</a>
          </div>

          <p class="signup-text">Don't have an account? <router-link to="/register">Sign Up</router-link></p>
        </form>
      </div>

      <p class="version-text">Version {{ version }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data: function () {
    return {
      username: window.localStorage.getItem('remembered_username') || '',
      password: '',
      errorMsg: '',
      loading: false,
      showPassword: false,
      rememberUsername: !!window.localStorage.getItem('remembered_username'),
      version: version,
      platformId: cordova.platformId
    }
  },
  mounted: function () {
    this.$store.commit('SET_LAYOUT', 'AuthLayout')
     if(cordova.platformId != "browser"){
   window.plugins.imeiGetter.get(function(imei){
       console.log(imei);
        window.localStorage.setItem('imei',device.imei)
    }, function(err){
       console.error("Oh..", err);
        window.localStorage.setItem('imei','')
    });

    window.localStorage.setItem('uuid',device.uuid)
    window.localStorage.setItem('version',device.version)
    window.localStorage.setItem('device_name',device.manufacturer+" "+device.model)
 }
 
  },
  methods: {
    ForgotP: function () {
      var url = "https://admin.medicater.co.za/login/forgot_password"
      cordova.InAppBrowser.open(url, '_blank');
    },
    login: function () {
      var that = this
      that.errorMsg = ''
      that.loading = true
      if (that.rememberUsername) {
        window.localStorage.setItem('remembered_username', that.username)
      } else {
        window.localStorage.removeItem('remembered_username')
      }

        var data = {
          username: this.username,
          password: this.password,
          deviceId: window.localStorage.getItem('deviceId'),
          imei: window.localStorage.getItem('imei'),
          uuid: window.localStorage.getItem('uuid'),
          device_name: window.localStorage.getItem('device_name'),
          os_version: window.localStorage.getItem('version'),
          os:cordova.platformId
        }

        if(cordova.platformId != "browser"){
            data = {
              username: this.username,
              password: this.password,
              deviceId: window.localStorage.getItem('deviceId'),
              imei: window.localStorage.getItem('imei'),
              uuid: device.uuid,
              device_name: device.manufacturer+" "+device.model,
              os_version: device.version,
              os:cordova.platformId
            }

        }

        $.ajax({
          url: this.$config.apiUrl + 'basic/login',
          type: 'post',
          data: JSON.stringify(data),
          success: function (data) {
            that.loading = false
            if (typeof data.success !== 'undefined' && data.success === true) {
              window.localStorage.setItem('user', JSON.stringify(data.data))
              window.localStorage.setItem('token', data.meta.token)
              window.localStorage.setItem('username', that.username)
              window.localStorage.setItem('password', that.password)
              window.localStorage.setItem('review_questions', JSON.stringify(data.data.review_questions))
              if(data.data.is_first_signup == 'Y'){
                that.$router.push('/updatePassword')
                return false
              }
              that.$router.push('/')
            } else {
              var meta = JSON.parse(data.responseText)
              that.showError(meta.meta.reason)
            }
          },
          error: function (data) {
            that.loading = false
            var meta = JSON.parse(data.responseText)
            that.showError(meta.meta.reason)
          }
        })

    },
    showError: function (message) {
      this.errorMsg = message
    }
  }
}
</script>

<style scoped>
/* ── Full-screen centred wrapper ── */
.login-wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #77d1f3 0%, #3aacd6 45%, #1a7fa8 100%);
  overflow-y: auto;
  padding: 24px 16px;
}

/* Decorative blobs */
.login-wrapper::before {
  content: '';
  position: fixed;
  top: -120px;
  left: -100px;
  width: 380px;
  height: 380px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  pointer-events: none;
}
.login-wrapper::after {
  content: '';
  position: fixed;
  bottom: -100px;
  right: -80px;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  pointer-events: none;
}

/* ── Container ── */
.login-container {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  position: relative;
  z-index: 1;
}

/* ── Logo ── */
.login-logo img {
  max-width: 150px;
  filter: drop-shadow(0 6px 18px rgba(0, 0, 0, 0.2));
}

/* ── Card ── */
.login-card {
  width: 100%;
  background: #fff;
  border-radius: 24px;
  padding: 36px 32px 28px;
  box-shadow: 0 24px 64px rgba(15, 61, 92, 0.22);
}

/* ── Header ── */
.login-header {
  text-align: center;
  margin-bottom: 28px;
}

.login-header h2 {
  font-size: 1.6rem;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 6px;
  letter-spacing: -0.3px;
}

.login-header p {
  font-size: 0.875rem;
  color: #94a3b8;
  margin: 0;
}

/* ── Inputs ── */
.input-group {
  position: relative;
  margin-bottom: 14px;
}

.input-group .input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 0.95rem;
  pointer-events: none;
  display: flex;
  align-items: center;
}

.input-group input {
  width: 100%;
  padding: 13px 16px 13px 42px;
  border: 1.5px solid #e8edf2;
  border-radius: 12px;
  font-size: 0.95rem;
  color: #0f172a;
  background: #f8fafc;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  box-sizing: border-box;
  outline: none;
}

.input-group input:focus {
  border-color: #1a587b;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(26, 88, 123, 0.12);
}

.input-group input { padding-right: 44px; }
.input-group input::placeholder { color: #b0bcc8; }

.eye-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  font-size: 1rem;
  transition: color 0.15s;
}
.eye-toggle:hover { color: #1a587b; }

.remember-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  cursor: pointer;
}
.remember-check {
  width: 16px;
  height: 16px;
  accent-color: #1a587b;
  cursor: pointer;
}
.remember-label {
  font-size: 0.85rem;
  color: #64748b;
  font-weight: 500;
  user-select: none;
}

/* ── Error ── */
.error-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff5f5;
  border: 1px solid #fecaca;
  color: #dc2626;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 0.85rem;
  margin-bottom: 14px;
}

/* ── Sign in button ── */
.login-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.1s;
  margin-top: 6px;
  letter-spacing: 0.3px;
  box-shadow: 0 6px 20px rgba(26, 88, 123, 0.35);
}
.login-btn:hover  { opacity: 0.92; }
.login-btn:active { transform: scale(0.98); }
.login-btn:disabled { opacity: 0.8; cursor: not-allowed; transform: none; }

/* ── Button spinner ── */
.btn-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.btn-spinner {
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2.5px solid transparent;
  border-top-color: rgba(255, 255, 255, 0.9);
  border-left-color: rgba(255, 255, 255, 0.9);
  animation: btn-spin 0.9s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite;
  flex-shrink: 0;
}
.btn-spinner::after {
  content: '';
  position: absolute;
  inset: 3px;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: rgba(255, 255, 255, 0.35);
  border-left-color: rgba(255, 255, 255, 0.35);
  animation: btn-spin 1.8s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite reverse;
}
@keyframes btn-spin { to { transform: rotate(360deg); } }

/* ── Forgot password ── */
.login-links {
  text-align: center;
  margin-top: 16px;
}

.login-links a {
  font-size: 0.85rem;
  color: #1a587b;
  text-decoration: none;
  font-weight: 600;
}
.login-links a:hover { text-decoration: underline; }

/* ── Divider ── */
.login-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 18px 0 0;
  color: #cbd5e1;
  font-size: 0.75rem;
}
.login-divider::before,
.login-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #e8edf2;
}

/* ── Sign-up text ── */
.signup-text {
  text-align: center;
  margin-top: 16px;
  font-size: 0.85rem;
  color: #64748b;
}
.signup-text a { color: #1a587b; font-weight: 700; text-decoration: none; }
.signup-text a:hover { text-decoration: underline; }

/* ── Version ── */
.version-text {
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  letter-spacing: 0.3px;
}

/* ── Fade transition ── */
.fade-enter-active, .fade-leave-active { transition: opacity 0.25s; }
.fade-enter, .fade-leave-to { opacity: 0; }
</style>
